import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Fires when a user submits a new email address from Account Settings and the server accepts the request (pending verification)',
  name: 'email_change_requested',
  params: [
    {
      description: 'The id of the user changing their email',
      name: 'user_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The new email address the user wants to change to',
      name: 'new_email',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
